import React from 'react';
import { Header } from '@appkit4/react-components/header';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import AvatarDropdown from './AvatarDropdown';
import { AppRoutes } from '../../Constants';
import useLocale from '../../locale/useLocale';
import './Navigation.scss';
import { Tooltip } from '@appkit4/react-components';

const BasicNavigation = () => {
    const navigate = useNavigate();
    const auth = useAuth();
    const { l } = useLocale();

    const titleTemplate = () => (
        <Link
            to={
                auth.isAuthenticated
                    ? AppRoutes.HomePage
                    : AppRoutes.LandingPage
            }
            style={{
                fontWeight: 'normal',
                textDecorationLine: 'none',
            }}
        >
            {l('_applicationName')}
        </Link>
    );

    const optionsTemplate = () => {
        return (
            <>
                <Tooltip
                    trigger="hover"
                    position="top-left"
                    id="tooltipDesc"
                    appendAfterTarget={true}
                    content="Extraction process settings"
                >
                    <span
                        className="Appkit4-icon icon-setting-outline"
                        onClick={() => navigate(AppRoutes.ExtractionSettings)}
                        style={{ cursor: 'pointer' }}
                    ></span>
                </Tooltip>
            </>
        );
    };

    const userTemplate = () =>
        auth.isAuthenticated ? <AvatarDropdown /> : null;

    const handleLogoNavigation = () =>
        auth.isAuthenticated
            ? navigate(AppRoutes.HomePage)
            : navigate(AppRoutes.LandingPage);

    return (
        <div className="navigation-wrapper">
            <Header
                role="navigation"
                hasLogo
                type="solid"
                titleTemplate={titleTemplate}
                optionsTemplate={optionsTemplate}
                userTemplate={userTemplate}
                onClickLogo={handleLogoNavigation}
                className="position-sticky"
                style={{ top: '0' }}
            />
        </div>
    );
};

export default BasicNavigation;
